module.exports = __webpack_public_path__ + "img/living.f8396d54.svg";